module.exports = __webpack_public_path__ + "static/media/038-dashboard.598ddb20.svg";